import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./BoostBolt.scss";

const BoostBolt = ({ className, white }) => (
	<span
		className={classnames("boostbolt", className, {
			"boostbolt--white": white,
		})}
		data-tooltip="Via Boost"
		data-tooltip-padding="5"
	/>
);

BoostBolt.propTypes = {
	className: PropTypes.string,
	white: PropTypes.bool,
};

BoostBolt.defaultProps = {
	className: null,
	white: false,
};

export default BoostBolt;



// WEBPACK FOOTER //
// ./src/shared/components/BoostBolt.jsx